import React from "react";

const OverviewHeader: React.FC = () => {
    return (
        <div className="w-full border border-gray-200 rounded-lg p-4 flex flex-row items-center justify-between">
            <div className="flex flex-col items-start justify-center gap-y-2 w-[30%]">
                <span className="text-4xl font-semibold">2,487</span>
                <span className="text-base font-normal">Total SKUs</span>
            </div>
            <div className="h-[120px] border-[0.2px] border-gray-300 mx-6" />
            <div className="flex flex-col items-start justify-center gap-y-2 w-[30%]">
                <span className="text-4xl font-semibold">412</span>
                <span className="text-base font-normal">Low Stock Items</span>
            </div>
            <div className="h-[120px] border-[0.2px] border-gray-300 mx-6" />
            <div className="flex flex-col items-start justify-center gap-y-2 w-[30%]">
                <span className="text-4xl font-semibold">1,245</span>
                <span className="text-base font-normal">Units Moved Today</span>
            </div>
        </div>
    );
}

export default OverviewHeader